import * as utility from '../misc/utility';

/**
 * @typedef { import('./ApiService').ApiService } ApiService
*/

export class ResourceEndpoint {
    /**
     * @param {string} url
     * @param {ApiService} api
     * @param {any} resourceConstructor
     */
    constructor(url, api, resourceConstructor) {
        this.url = url;
        this.resourceConstructor = resourceConstructor;
        this._api = api;
    }

    list() {
        return this.search({});
    }

    search(searchCriteria) {
        var dst = this.url + '/search';
        return this._api.postResponse(dst, searchCriteria)
            .then(rsp => rsp.parseEntity(this.resourceConstructor));
    }

    get(id) {
        if (!utility.isGuid(id))
            throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id);
        return this._api.getResponse(dst)
            .then(rsp => rsp.parseEntity(this.resourceConstructor));
    }

    addEntity(obj) {
        if (!(obj instanceof this.resourceConstructor)) {
            throw new TypeError('Invalid Argument');
        }
        var dst = this.url;
        return this._api.postResponse(dst, obj)
            .then(rsp => rsp.createEntityResponse(this.resourceConstructor));
    }

    updateEntity(obj) {
        if (!(obj instanceof this.resourceConstructor)) {
            throw new TypeError('Invalid Argument');
        }
        var dst = this.url + '/' + encodeURIComponent(obj.Id);
        return this._api.putResponse(dst, obj)
            .then(rsp => rsp.createEntityResponse(this.resourceConstructor));
    }

    activate(id) {
        if (!utility.isGuid(id))
            throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/activate';
        return this._api.postVoid(dst, {});
    }

    archive(id) {
        if (!utility.isGuid(id))
            throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/archive';
        return this._api.postVoid(dst, {});
    }

    hardRemove(id) {
        if (!utility.isGuid(id))
            throw "Invalid parameter, expected GUID";

        var dst = this.url + '/' + encodeURIComponent(id) + '/delete';
        return this._api.postVoid(dst, {});
    }

    updateSorting(items) {
        var dst = this.url + '/sorting';
        return this._api.putVoid(dst, items);
    }
}
